var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgDoc(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5,
    d: "M20.104 4L26 9.834V28H7V4h13.104zm-.572.8H7.809v22.4H25.19V10.4h-5.66V4.8zM13.62 20.088a.407.407 0 01.568.062.397.397 0 01-.04.543l-.023.02-2.022 1.6a.404.404 0 01-.51-.006l-.028-.024-.808-.8a.397.397 0 010-.566c.15-.15.39-.156.55-.02l.021.02.553.547 1.739-1.376zm7.933 1.112c.223 0 .404.179.404.4a.402.402 0 01-.376.4h-6.496a.402.402 0 01-.404-.4c0-.212.166-.385.376-.4h6.496zm-7.933-5.512a.407.407 0 01.568.062.397.397 0 01-.04.543l-.023.02-2.022 1.6a.404.404 0 01-.51-.006l-.028-.024-.808-.8a.397.397 0 010-.566c.15-.15.39-.156.55-.02l.021.02.553.547 1.739-1.376zm7.933 1.112c.223 0 .404.179.404.4a.402.402 0 01-.376.4h-6.496a.402.402 0 01-.404-.4c0-.212.166-.385.376-.4h6.496zm-7.933-5.512a.407.407 0 01.568.062.397.397 0 01-.04.543l-.023.02-2.022 1.6a.404.404 0 01-.51-.006l-.028-.024-.808-.8a.397.397 0 010-.566c.15-.15.39-.156.55-.02l.021.02.553.547 1.739-1.376zm7.933 1.112c.223 0 .404.179.404.4a.402.402 0 01-.376.4h-6.496a.402.402 0 01-.404-.4c0-.212.166-.385.376-.4h6.496zM20.34 5.366V9.6h4.28l-4.28-4.234z"
  }));
}

export default SvgDoc;